"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_ADMIN_USER = exports.CREATE_ADMIN_USER = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const schemaComponents_1 = require("@/schemaComponents");
const function_client_1 = require("@/utils/function-client");
const react_bootstrap_1 = require("react-bootstrap");
const models_hook_1 = require("app/models.hook");
const __1 = require("..");
const schema_1 = __importDefault(require("./schema"));
const preview_1 = require("./preview");
const auth_1 = require("common/auth");
const index_1 = require("../../../index");
exports.CREATE_ADMIN_USER = __1.ADMIN_USERS.sub("/new", AdminUser);
exports.UPDATE_ADMIN_USER = __1.ADMIN_USER.sub("", AdminUser);
function AdminUser({ adminUserId }) {
    (0, auth_1.useAdminPageAuthorization)();
    const [error, setError] = (0, react_1.useState)();
    const { data, loading, set, remove, isEditing } = (0, models_hook_1.useAdminUserDoc)({
        adminUserId,
    });
    const { setAtomic: setForNewItem } = (0, models_hook_1.useAdminUserDoc)({});
    const parameter = {
        title: isEditing ? "システムユーザ詳細" : "システムユーザ新規作成",
        schema: (0, schema_1.default)({ isEditing }),
        edit: {
            title: `${isEditing ? "保存" : "保存"}`,
            confirm: `${isEditing ? "保存" : "保存"}しますか？`,
            handler: (value) => __awaiter(this, void 0, void 0, function* () {
                if (isEditing) {
                    yield set(value);
                }
                else {
                    // Check if the user exists on Firebase Authentication
                    const { uid } = (yield (0, function_client_1.getAdminUser)({ email: value.initialEmail })) || {};
                    if (uid) {
                        yield setForNewItem(Object.assign(Object.assign({}, value), { adminUserId: uid }), (data, oldData) => {
                            if (oldData) {
                                setError({
                                    message: (react_1.default.createElement("span", null,
                                        "\u540C\u3058\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306E\u30E6\u30FC\u30B6\u304C\u5B58\u5728\u3057\u307E\u3059\u3002\u7DE8\u96C6\u3059\u308B\u5834\u5408\u306F",
                                        react_1.default.createElement(react_router_dom_1.Link, { onClick: () => setError(undefined), to: (0, index_1.resolveRoute)("UPDATE_ADMIN_USER", {
                                                adminUserId: uid,
                                            }) }, "\u3053\u3061\u3089"),
                                        "\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044")),
                                });
                                throw new Error("An account binded to the specified email already exists");
                            }
                            return data;
                        });
                    }
                    else {
                        // new user (both authentication and firestore)
                        yield set(value);
                    }
                }
            }),
        },
        back: {},
        remove: isEditing ? { handler: remove } : undefined,
        preview: {
            title: "ユーザ認証情報",
            component: preview_1.PreviewComponent,
        },
        backPath: (0, index_1.resolveRoute)("LIST_ADMIN_USER"),
        header: {
            isStacked: true,
        },
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        error && react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, error.message),
        react_1.default.createElement(schemaComponents_1.SchemaFormPage, { data: data, parameter: parameter, loading: !!(isEditing && loading), editModeEnabled: true })));
}
exports.default = AdminUser;
